<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <h3>Update Server</h3>

        <br />
        <!-- Feedback -->
        <div v-if="file && !isAllowed" class="alert alert-danger" role="alert">
          That file type is not allowed
        </div>
        <div v-if="!upload.success && upload.message">
          <p class="font-italic">
            The file failed to upload. See below for details.
          </p>
          <div class="alert alert-danger" v-html="upload.message"></div>
        </div>
        <div v-if="upload.success && upload.status === 200"
          class="alert alert-success d-flex justify-content-between align-items-center" role="alert">
          Reboot the server to apply the update
          <button type="button" class="btn btn-hub-primary" @click="reboot()"
            title="Reboot the machine">Reboot</button>
        </div>

        <!-- Upload Form -->
        <form enctype="multipart/form-data">
          <div class="form-group">
            <div class="input-group mb-3">
              <div class="custom-file update-server-file">
                <input type="file" class="custom-file-input" accept=".gz" @change="processFile($event)">
                <label class="custom-file-label">{{ file_name }}</label>
              </div>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-hub-primary btn-block"
            @click="uploadUpdateFile()"
            v-bind:disabled="!isFileValid || upload.inProgress"
          >
            <span v-if="upload.inProgress">
              <i class="fa fa-circle-notch fa-fw fa-spin fa-lg"></i>
              <span class="sr-only">Loading...</span>
            </span>
            <span v-else>Upload</span>
          </button>
        </form>
      </div>
    </div>

    <button
      type="button"
      id="countdownModalBtn"
      class="btn btn-hub-primary invisible"
      data-toggle="modal"
      data-target="#countdownModal" />

    <!-- Modal -->
    <div class="modal fade" id="countdownModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ timer.finished ? 'Update Finished' : 'Applying Update...' }}
            </h5>
          </div>
          <div class="modal-body">
            <div v-if="timer.seconds > 0">Estimated time remaining: {{timer.seconds}} seconds</div>
            <div v-else>Refresh to load the latest updates. You may be required to login again.</div>
          </div>
          <div class="modal-footer">
            <button type='button' v-bind:disabled="!timer.finished"
              class="btn btn-hub-primary" onClick="window.location.reload()">
              {{ timer.finished ? 'Refresh' : 'Please Wait...' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data: function () {
    return {
      allowedTypes: ['application/gzip', 'application/x-gzip'],
      file_name: 'Choose File',
      file: undefined,
      isAllowed: false,
      isFileValid: false,
      timer: {
        finished: false,
        seconds: 60
      },
      type: '0',
      upload: {
        inProgress: false
      }
    }
  },
  computed: {
    fileStatusClass: function () {
      return {
        'text-success': (this.file && this.isFileValid),
        'text-danger': (this.file && !this.isFileValid)
      }
    }
  },
  methods: {
    ...mapActions([
      'executeConsoleCommand'
    ]),
    validateFile (file) {
      // Check file type
      if (!this.allowedTypes.includes(file.type)) {
        this.isAllowed = false
        return false
      }
      this.isAllowed = true

      return true
    },
    processFile (event) {
      const [ file ] = event.target.files

      this.file = file
      this.file_name = file.name

      this.isFileValid = this.validateFile(file)
    },
    onUploadSuccess ({ data, status }) {
      this.upload.inProgress = false
      this.upload = {
        success: data.success,
        message: data.message,
        status
      }
    },
    onUploadFail (error) {
      this.upload.inProgress = false
      const response = error.response || {
        data: 'Network Error',
        status: 500
      }

      this.upload = {
        success: false,
        message: response.data,
        status: response.status
      }
    },
    uploadUpdateFile () {
      if (!this.isFileValid) return alert('The file is not valid')

      this.upload.inProgress = true
      this.$store.dispatch('uploadUpdateFile', {
        file: this.file,
        onUploadSuccess: this.onUploadSuccess,
        onUploadFail: this.onUploadFail
      })
    },
    startTimer () {
      const updateTimer = setInterval(() => {
        --this.timer.seconds

        if (this.timer.seconds <= 0) {
          clearInterval(updateTimer)
          this.timer.finished = true
        }
      }, 1000)
    },
    reboot () {
      this.executeConsoleCommand('reboot')
      this.startTimer()

      // open modal
      document.getElementById('countdownModalBtn').click()
    }
  }
}
</script>

<style>
  .update-server-file {
    width: 100%
  }
  .update-server-file .custom-file-input {
    cursor: pointer;
    width: 100%;
  }
  .update-server-file .custom-file-control::after {
    content: '';
  }
</style>
